import { render, staticRenderFns } from "./GetSizeBox24.vue?vue&type=template&id=6e40d7ec&scoped=true&"
import script from "./GetSizeBox24.vue?vue&type=script&lang=js&"
export * from "./GetSizeBox24.vue?vue&type=script&lang=js&"
import style0 from "./GetSizeBox24.vue?vue&type=style&index=0&id=6e40d7ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e40d7ec",
  null
  
)

export default component.exports